<!-- footer wrapper -->
<div class="footer">
  <div fxLayoutAlign="space-between center" class="footer-content-wrapper">
    <!-- content wrapper -->
    <div fxLayoutAlign="start center" class="notranslate" *ngIf="orgName === 'ICRISAT'" fxLayoutGap="5px">
      <!-- icrisat logo which on click goes to icrisat homepage -->
      <a href="https://www.icrisat.org/" class="notranslate" target="_blank" matTooltip="ICRISAT Home">
        <img src="assets/images/ICRISAT/logo/short_logo.png" alt="ICRISAT" height="25 "></a>


      <a mat-button class="navbar-icon-button notranslate" target="_blank" matTooltip="LinkedIn"
        href="https://www.linkedin.com/company/icrisat">
        <mdb-icon class="org-icons" fab icon="linkedin"></mdb-icon>
      </a>

      <a mat-button class="navbar-icon-button notranslate" target="_blank" matTooltip="Facebook"
        href="https://www.facebook.com/ICRISAT">
        <mdb-icon class="org-icons" fab icon="facebook"></mdb-icon>
      </a>

      <a mat-button class="navbar-icon-button notranslate" target="_blank" matTooltip="YouTube"
        href="https://www.youtube.com/user/icrisatco">
        <mdb-icon class="org-icons" fab icon="youtube"></mdb-icon>
      </a>

      <a mat-button class="navbar-icon-button notranslate" target="_blank" matTooltip="Twitter"
        href="https://twitter.com/ICRISAT">
        <img src="assets/images/REZAYAT/logo/twitter-logo-share.png" height="20">
      </a>

      <a mat-button class="navbar-icon-button notranslate" target="_blank" matTooltip="SlideShare"
        href="http://www.slideshare.net/icrisatsmco">
        <mdb-icon class="org-icons" fab icon="slideshare"></mdb-icon>
      </a>

      <a mat-button class="navbar-icon-button notranslate" target="_blank" matTooltip="Instagram"
        href="https://www.instagram.com/icrisat_official/">
        <mdb-icon class="org-icons" fab icon="instagram"></mdb-icon>
      </a>
    </div>

    <div fxLayoutAlign="start center" *ngIf="orgName === 'REZAYAT'" fxLayoutGap="5px">

      <a href="" matTooltip="REZAYAT Home" target="_blank">
        <img src="assets/images/REZAYAT/logo/short_logo.png" alt="REZAYAT" height="20">
      </a>

      <!-- linkedin -->
      <a mat-button class="navbar-icon-button" target="_blank" matTooltip="LinkedIn"
        href="https://www.linkedin.com/company/rezayat-group">
        <mdb-icon class="org-icons" fab icon="linkedin"></mdb-icon>
      </a>

      <!-- facebook -->
      <!-- <a mat-icon-button target="_blank" matTooltip="Facebook" href="">
        <mdb-icon class="org-icons" fab icon="facebook"></mdb-icon>
      </a> -->

      <!-- youtube -->
      <a mat-button class="navbar-icon-button" target="_blank" matTooltip="YouTube" href="">
        <mdb-icon class="org-icons" fab icon="youtube"></mdb-icon>
      </a>

      <!-- twitter -->
      <a mat-button class="navbar-icon-button" target="_blank" matTooltip="Twitter" href="">
        <img src="assets/images/REZAYAT/logo/twitter-logo-share.png" height="8">
      </a>

      <!-- slideshare -->
      <a mat-button class="navbar-icon-button" target="_blank" matTooltip="SlideShare" href="">
        <mdb-icon class="org-icons" fab icon="slideshare"></mdb-icon>
      </a>


    </div>

    <div fxLayoutAlign="start center" *ngIf="orgName === 'HYPERLOOP'" fxLayoutGap="5px">

      <a href="" matTooltip="HYPERLOOP Home" target="_blank">
        <img src="assets/images/HYPERLOOP/logo/full_logo.png" alt="HYPERLOOP" height="20">
      </a>

      <!-- linkedin -->
      <a mat-button class="navbar-icon-button" target="_blank" matTooltip="LinkedIn" href="">
        <mdb-icon class="org-icons" fab icon="linkedin"></mdb-icon>
      </a>

      <!-- facebook -->
      <a mat-button class="navbar-icon-button" target="_blank" matTooltip="Facebook" href="">
        <mdb-icon class="org-icons" fab icon="facebook"></mdb-icon>
      </a>

      <!-- youtube -->
      <a mat-button class="navbar-icon-button" target="_blank" matTooltip="YouTube" href="">
        <mdb-icon class="org-icons" fab icon="youtube"></mdb-icon>
      </a>

      <!-- twitter -->
      <a mat-button class="navbar-icon-button" target="_blank" matTooltip="Twitter" href="">
        <img src="assets/images/HYPERLOOP/logo/twitter-logo-share.png" height="20">
      </a>


      <!-- slideshare -->
      <a mat-button class="navbar-icon-button" target="_blank" matTooltip="SlideShare" href="">
        <mdb-icon class="org-icons" fab icon="slideshare"></mdb-icon>
      </a>
    </div>

    <!-- NAQUA -->
    <div fxLayoutAlign="start center" class="notranslate" *ngIf="orgName === 'NAQUA'" fxLayoutGap="5px">

      <a href="https://www.naqua.com.sa/en/home" class="notranslate" target="_blank" matTooltip="NAQUA Home">
        <img src="assets/images/NAQUA/logo/logo.png" alt="NAQUA" height="40">
      </a>

      <!-- linkedin -->
      <a mat-button class="navbar-icon-button notranslate" target="_blank" matTooltip="LinkedIn"
        href="https://www.linkedin.com/company/naquaseafood/">
        <mdb-icon class="org-icons" fab icon="linkedin"></mdb-icon>
      </a>

      <!-- facebook -->
      <a mat-button class="navbar-icon-button notranslate" target="_blank" matTooltip="Facebook"
        href="https://www.facebook.com/NaquaSeafood/">
        <mdb-icon class="org-icons" fab icon="facebook"></mdb-icon>
      </a>

      <!-- youtube -->
      <a mat-button class="navbar-icon-button notranslate" target="_blank" matTooltip="YouTube"
        href="https://www.youtube.com/@nationalaquaculture">
        <mdb-icon class="org-icons" fab icon="youtube"></mdb-icon>
      </a>

      <!-- twitter -->
      <a mat-button class="navbar-icon-button notranslate" target="_blank" matTooltip="Twitter"
        href="https://x.com/naquaseafood">
        <img src="assets/images/HYPERLOOP/logo/twitter-logo-share.png" height="20">
      </a>

      <!-- slideshare -->
      <!-- <a mat-button class="navbar-icon-button notranslate" target="_blank" matTooltip="SlideShare" href="">
        <mdb-icon class="org-icons" fab icon="slideshare"></mdb-icon>
      </a> -->
      <!-- pinterest -->
      <a mat-button class="navbar-icon-button notranslate" target="_blank" matTooltip="Pinterest"
        href="https://www.pinterest.com/naquaseafood/national-aquaculture-group/">
        <mdb-icon class="org-icons" fab icon="pinterest"></mdb-icon>
      </a>
      <!-- Instagram -->
      <a mat-button class="navbar-icon-button notranslate" target="_blank" matTooltip="Instagram"
        href="https://www.instagram.com/naquaseafood/">
        <mdb-icon class="org-icons" fab icon="instagram"></mdb-icon>
      </a>
    </div>

    <div *ngIf="orgName === 'CRESCOWORKS'">
      <a href="http://crescoworks.com/" target="_blank"> <img src="assets/images/CRESCOWORKS/logo/short_logo.png"
          alt="CrescoWorks" height="25 "></a>
    </div>

    <!-- copyrights section -->
    <div fxLayoutAlign="center end" fxLayout="row">
      <p class="footer-logo" fxLayout="row" fxLayoutAlign="center baseline" fxLayoutGap="5px">
        <img src="assets/images/CrescoWorks/logo/short_logo.png" alt="CrescoWorks" height="13">
        <a href="http://crescoworks.com/" class="footer-logo" matTooltip="CrescoWorks Website" target="_blank">
          CrescoWorks LLP&nbsp;</a>
      </p>
      <p class="footer-copyrights">
        © {{currentYear}}, All rights reserved.
      </p>
    </div>
  </div>
</div>